import { Users } from 'lucide-react';
import OrgChart from './OrgChart';

export default function OrganigrammeTab() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="text-lg md:text-xl font-bold text-white flex items-center gap-2">
          <Users className="w-5 h-5 text-indigo-300" />
          Organigramme CE & directions
        </h3>
        <p className="text-xs md:text-sm text-slate-200/90">
          Matrice vivante — structure, responsabilités, liens hiérarchiques &amp; fonctionnels. Vue exécutive par défaut,
          détaillable en un clic par personne ou par comité.
        </p>
      </div>

      <OrgChart />
    </div>
  );
}

